import { createFileRoute, redirect } from '@tanstack/react-router'
import { DepositForm } from '@/features/accounting-bank/deposit-form'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/accounting/deposits/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bank.create'))
      throw redirect({ to: '/accounting/deposits' })
  },
  component: DepositForm,
})
